<div class="legal-page">
  <div class="legal-hero">
    <div class="legal-hero__bg"></div>
    <div class="legal-hero__content">
      <a class="legal-hero__back" routerLink="/home">
        <i class="fas fa-arrow-left"></i> Retour a l'accueil
      </a>
      <div class="legal-hero__icon"><i class="fas fa-gavel"></i></div>
      <h1>Mentions Legales</h1>
      <p class="legal-hero__subtitle">Informations juridiques relatives au site et a l'application BeeKids</p>
    </div>
  </div>

  <div class="legal-body">
    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-building"></i></div>
        <h2>Editeur du site</h2>
      </div>
      <div class="legal-card__body">
        <div class="legal-info-grid">
          <div class="legal-info-item">
            <span class="legal-info-item__label">Societe</span>
            <span class="legal-info-item__value">STE DIGITAL POWR CONSULTING</span>
          </div>
          <div class="legal-info-item">
            <span class="legal-info-item__label">Forme juridique</span>
            <span class="legal-info-item__value">Societe a responsabilite limitee (SARL)</span>
          </div>
          <div class="legal-info-item">
            <span class="legal-info-item__label">Adresse du siege social</span>
            <span class="legal-info-item__value">Tunis, Tunisie</span>
          </div>
          <div class="legal-info-item">
            <span class="legal-info-item__label">Matricule fiscal / RNE</span>
            <span class="legal-info-item__value">1324048Y</span>
          </div>
          <div class="legal-info-item">
            <span class="legal-info-item__label">ID Commercant (Flouci)</span>
            <span class="legal-info-item__value">5322</span>
          </div>
          <div class="legal-info-item">
            <span class="legal-info-item__label">Telephone</span>
            <span class="legal-info-item__value">+216 29 370 239</span>
          </div>
          <div class="legal-info-item">
            <span class="legal-info-item__label">Email</span>
            <span class="legal-info-item__value">contact&#64;beekids.tn</span>
          </div>
          <div class="legal-info-item">
            <span class="legal-info-item__label">Directeur de publication</span>
            <span class="legal-info-item__value">M. Jassem Sghair</span>
          </div>
        </div>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-server"></i></div>
        <h2>Hebergeur</h2>
      </div>
      <div class="legal-card__body">
        <div class="legal-info-grid">
          <div class="legal-info-item">
            <span class="legal-info-item__label">Hebergeur</span>
            <span class="legal-info-item__value">OVH SAS</span>
          </div>
          <div class="legal-info-item">
            <span class="legal-info-item__label">Adresse</span>
            <span class="legal-info-item__value">2 Rue Kellermann, 59100 Roubaix, France</span>
          </div>
        </div>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-shield-alt"></i></div>
        <h2>Propriete intellectuelle</h2>
      </div>
      <div class="legal-card__body">
        <p>L'ensemble du contenu de ce site (textes, images, videos, logos, graphismes, logiciels) est la propriete exclusive de STE DIGITAL POWR CONSULTING ou de ses partenaires. Toute reproduction, representation ou modification, totale ou partielle, est interdite sans autorisation prealable.</p>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-cookie-bite"></i></div>
        <h2>Cookies</h2>
      </div>
      <div class="legal-card__body">
        <p>Ce site utilise des cookies pour ameliorer l'experience utilisateur et mesurer l'audience. Vous pouvez configurer votre navigateur pour refuser les cookies.</p>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-user-shield"></i></div>
        <h2>Donnees personnelles</h2>
      </div>
      <div class="legal-card__body">
        <p>Conformement au RGPD et a la loi tunisienne 2018-50 relative a la protection des donnees a caractere personnel, vous disposez d'un droit d'acces, de rectification et de suppression de vos donnees.</p>
        <a class="legal-card__cta" href="mailto:privacy@beekids.tn">
          <i class="fas fa-envelope"></i> Contactez-nous a privacy&#64;beekids.tn
        </a>
      </div>
    </div>

    <div class="legal-card">
      <div class="legal-card__header">
        <div class="legal-card__icon"><i class="fas fa-headset"></i></div>
        <h2>Contact</h2>
      </div>
      <div class="legal-card__body">
        <p>Pour toute question legale, contactez-nous :</p>
        <a class="legal-card__cta" href="mailto:legal@beekids.tn">
          <i class="fas fa-envelope"></i> legal&#64;beekids.tn
        </a>
      </div>
    </div>
  </div>
</div>
